<template>
  <div class="stockApp">
    <div class="stock">
      <Header></Header>
      <main>
        <div class="mainBottom">
          <!-- 右侧内容 -->
          <div class="right">
            <div class="mainTop">
              <div class="underHeader">
                <img src="../../assets/img/info.png" alt />
                当前位置：
              </div>
              <el-breadcrumb
                separator-class="el-icon-arrow-right"
                style="width:50%;height: 54px;display: inline-block;line-height: 54px;"
              >
                <el-breadcrumb-item :to="{ path: '/' }">平台首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{path:'/searchPage'}">企业搜索</el-breadcrumb-item>
                <el-breadcrumb-item>{{companyName}}</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <div class="marinBottom_top">
              <div class="topBox_1">
                <div class="businessLabelBox">
                  <div class="img">
                    <img src="../../assets/img/gs.png" style="width:50px;height:49px;" alt />
                  </div>
                  <div class="column">
                    <div class="names">
                      <h3>{{businessLabel.company_name}}</h3>
                      <p v-if="businessLabel.management_forms">{{businessLabel.management_forms}}</p>
                    </div>
                    <div class="tags">
                      <p v-if="businessLabel.region">{{businessLabel.region}}</p>
                      <p
                        v-if="businessLabel.industry"
                        :title="industryTitle"
                      >{{businessLabel.industry}}</p>
                      <p v-for="(v,i) in specialLabel" :key="i" v-if="v.showName!=''">{{v.showName}}</p>
                    </div>
                    <div class="tags" v-for="(s,k) in specialLabel2" :key="k" v-if="showTags">
                      <p v-for="(v,i) in s" :key="i" v-if="v.showName!=''">{{v.showName}}</p>
                    </div>
                  </div>
                  <div class="ckgd" v-if="specialLabel2.length>0">
                    <span></span>
                    <span @click="ckgd">
                      查看更多
                      <img src="../../assets/img/top.png" v-if="showTags" alt />
                      <img src="../../assets/img/bottom.png" v-else alt />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="nav">
              <img src="../../assets/img/back.png" @click="back" alt />
              <p @click="back">返回{{companyName}}</p>
              <div>
                <p
                  v-for="(v,i) in navData"
                  :key="i"
                  :class="i==navInd?'navStyle':''"
                  @click="clickNav(i)"
                >{{v.name}}</p>
              </div>
            </div>
            <div class="bottom">
              <div id="chart1" v-if="navInd==0"></div>
              <div id="relation" v-if="navInd==1"></div>
              <gqjgt v-if="navInd==2" :companyName="companyName" :type="2"></gqjgt>
              <gqt3 v-if="navInd==3" :companyName="companyName" :type="3"></gqt3>
              <gqt4 v-if="navInd==4" :companyName="companyName" :type="4"></gqt4>
            </div>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import leftNav from "@/components/leftNav";
import api from "@/../static/common/api/api.js";
import gqt from "../../components/d3gqt/gqt";
import gqjgt from "../../components/gqjgt";
import http from "@/../static/common/api/axios";
import echarts from "echarts";
export default {
  props: {},
  components: {
    Header,
    Footer,
    leftNav,
    gqjgt,
    gqt1: gqt,
    gqt2: gqt,
    gqt3: gqt,
    gqt4: gqt
  },
  data() {
    return {
      navData: [
        { name: "企业图谱" },
        { name: "关系图谱" },
        { name: "股权结构" },
        { name: "股权穿透" },
        { name: "最终受益人" }
      ],
      businessLabel: [],
      specialLabel: [],
      specialLabel2: [],
      industryTitle: "",
      nom: "nlpapi/KG",
      showTags: false,
      // nom: "skt",
      navInd: 0,
      downward: [],
      upward: [],
      companyName: this.$route.query.companyName
    };
  },
  computed: {},

  methods: {
    ckgd() {
      this.showTags = !this.showTags;
    },
    clickNav(i) {
      this.navInd = i;
      if (i == 0) {
        http("post", this.nom + "/api", "json", {
          companyname: this.companyName,
          lable: "maps"
        }).then(res => {
          this.chart1(res.output);
        });
      } else if (i == 1) {
        http("post", this.nom + "/api", "json", {
          companyname: this.companyName,
          lable: "relation"
        }).then(res => {
          let data = [];
          let line = [];
          let { input, keypeople, output, out_investor } = res.output;
          this.relation(res.output);
        });
      }
    },
    back() {
      this.$router.go(-1);
    },
    chart1(data) {
      var chart1 = echarts.init(document.getElementById("chart1"));
      var baseName = this.companyName;
      // data.input_investor.forEach((v, i) => {
      //   v.name = v.investor;
      // });
      // data.out_investor.forEach((v, i) => {
      //   v.name = v.investor;
      // });
      var dataKey = ["控股企业", "公司高管", "对外投资"];
      var input_investor = data.input_investor;
      var keypeople = data.keypeople;
      var out_investor = data.out_investor;
      // var fact_income = data.fact_income;
      //   var chartData = {
      //   控股企业: data.input_investor,
      //   公司高管: data.keypeople,
      //   对外投资: data.out_investor
      // };

      var colors = [
        "#00ADD0",
        "#FFA12F",
        "#B62AFF",
        "#604BFF",
        "#6E35FF",
        "#002AFF",
        "#20C0F4",
        "#95F300",
        "#04FDB8",
        "#AF5AFF"
      ];
      var getdata = function getData() {
        let data = {
          name: baseName,
          children: []
        };
        for (let i = 0; i < dataKey.length; i++) {
          let obj = {
            name: dataKey[i],
            children: [],
            collapsed: true
          };
          if (dataKey[i] == "控股企业") {
            for (let j = 0; j < input_investor.length; j++) {
              let obj2 = {
                name: input_investor[j].name + input_investor[j].ratio
              };
              obj.children.push(obj2);
            }
          } else if (dataKey[i] == "公司高管") {
            for (let j = 0; j < keypeople.length; j++) {
              let obj2 = {
                name: keypeople[j].name + "-" + keypeople[j].duty
              };

              obj.children.push(obj2);
            }
          } else if (dataKey[i] == "对外投资") {
            for (let j = 0; j < out_investor.length; j++) {
              let obj2 = {
                name: out_investor[j].name + "-" + out_investor[j].ratio
              };
              obj.children.push(obj2);
            }
          }
          //  else if (dataKey[i] == "实际控股人") {
          //   for (let j = 0; j < fact_income.length; j++) {
          //     let obj2 = {
          //       name: fact_income[j].name + fact_income[j].ratio
          //     };
          //     obj.children.push(obj2);
          //   }
          // }

          data.children.push(obj);
        }
        let arr = [];
        arr.push(data);
        //
        arr = handle(arr, 0);
        // console.log(arr);
        return arr;
      };
      var handle = function handleData(data, index, color = "#00f6ff") {
        //index标识第几层
        return data.map((item, index2) => {
          //计算出颜色
          if (index == 1) {
            color = colors.find((item, eq) => eq == index2 % 10);
          }
          // 设置节点大小
          if (index === 0 || index === 1) {
            item.label = {
              position: "inside"
              //   rotate: 0,
              //   borderRadius: "50%",
            };
          }
          // 设置label大小
          switch (index) {
            case 0:
              item.symbolSize = 70;
              break;
            case 1:
              item.symbolSize = 50;
              break;
            default:
              item.symbolSize = 10;
              break;
          }
          // 设置线条颜色
          item.lineStyle = { color: color };

          if (item.children) {
            //存在子节点
            item.itemStyle = {
              borderColor: color,
              color: color
            };
            item.children = handle(item.children, index + 1, color);
          } else {
            //不存在
            item.itemStyle = {
              color: "transparent",
              borderColor: color
            };
          }
          return item;
        });
      };

      var option = {
        type: "tree",
        toolbox: {
          //工具栏
          show: false,
          iconStyle: {
            borderColor: "#03ceda"
          },
          feature: {
            restore: {}
          }
        },
        tooltip: {
          //提示框
          trigger: "item",
          triggerOn: "mousemove",
          backgroundColor: "rgba(1,70,86,1)",
          borderColor: "rgba(0,246,255,1)",
          borderWidth: 0.5,
          textStyle: {
            fontSize: 16
          }
        },
        series: [
          {
            type: "tree",
            hoverAnimation: true, //hover样式
            data: getdata(),
            top: 0,
            bottom: 40,
            left: 0,
            right: 0,
            layout: "radial",
            symbol: "circle",
            symbolSize: 10,
            nodePadding: 20,
            animationDurationUpdate: 750,
            expandAndCollapse: true, //子树折叠和展开的交互，默认打开
            initialTreeDepth: 2,
            roam: true, //是否开启鼠标缩放和平移漫游。scale/move/true
            focusNodeAdjacency: true,
            itemStyle: {
              borderWidth: 1
            },
            label: {
              //标签样式
              color: "#fff",
              fontSize: 16,
              fontFamily: "SourceHanSansCN",
              position: "inside",
              rotate: 0
            },
            lineStyle: {
              width: 1,
              curveness: 0.5
            }
          }
        ]
      };
      chart1.setOption(option);
    },
    relation(moduleDependencies) {
      var relation = echarts.init(document.getElementById("relation"));
      const defaultSymbolSize = 50;
      var edgeSymbol = ["", "arrow"];
      let data = {
        nodes: [
          {
            name: this.companyName,
            id: this.companyName,
            symbolSize: 100,
            category: 1
          }
        ],
        links: []
      };
      const color1 = "#5aa6ec";
      const color2 = "#ff7d18";
      const color3 = "#fd5a6e";
      function pushDataChildren(key, item) {
        let children = item.children;
        let keypeople = item.keypeople;

        var name = "";
        if (key == "input") {
          name = "当前股东";
        } else if (key == "output") {
          name = "对外投资";
        } else if (key == "keypeople") {
          name = "企业高管";
        }
        children.forEach((v, i) => {
          data.nodes.push({
            name: v.name,
            id: v.id ? v.id : item.personId,
            symbolSize: defaultSymbolSize,
            category:
              name == "当前股东"
                ? 0
                : name == "对外投资"
                ? 1
                : name == "企业高管"
                ? 2
                : ""
          });
          if (name == "当前股东") {
            data.links.push({
              source: v.id,
              target: item.id,
              name: "控股"
            });
          } else if (name == "对外投资") {
            data.links.push({
              source: v.id,
              target: item.id,
              name: "投资"
            });
          } else if (name == "企业高管") {
            data.links.push({
              source: item.id,
              target: v.id,
              name: item.duty
            });
          }

          if (v.keypeople) {
            if (v.keypeople.length > 0) {
              pushDataKeypeople(key, v);
            }
          }
          if (v.children) {
            if (v.children.length > 0) {
              pushDataChildren(key, v);
            }
          }
        });
      }
      function pushDataKeypeople(key, item) {
        var keypeople = item.keypeople;
        var name = "";
        if (key == "input") {
          name = "当前股东";
        } else if (key == "output") {
          name = "对外投资";
        } else if (key == "keypeople") {
          name = "企业高管";
        }
        keypeople.forEach((v, i) => {
          data.nodes.push({
            name: v.name,
            id: v.personId ? v.personId : item.id,
            symbolSize: defaultSymbolSize,
            category: 2
          });
          if (name == "当前股东") {
            data.links.push({
              source: v.personId,
              target: item.id,
              name: "控股"
            });
          } else if (name == "对外投资") {
            data.links.push({
              source: v.personId,
              target: item.id,
              name: "投资"
            });
          } else if (name == "企业高管") {
            data.links.push({
              source: v.personId,
              target: item.id,
              name: item.duty
            });
          }
          if (v.keypeople) {
            if (v.keypeople.length > 0) {
              pushDataKeypeople(key, v);
            }
          }
          if (v.children) {
            if (v.children.length > 0) {
              pushDataChildren(key, v);
            }
          }
        });

        var temp = {};
        data.nodes = data.nodes.reduce((prev, curv) => {
          if (temp[curv.name]) {
            // 如果临时对象中有这个名字，什么都不做
          } else {
            // 如果临时对象没有就把这个名字加进去，同时把当前的这个对象加入到prev中
            temp[curv.name] = true;
            prev.push(curv);
          }
          return prev;
        }, []);
      }
      // for (var [key, modules] of Object.entries(moduleDependencies)) {
      //   var name = "";
      //   if (key == "input") {
      //     name = "当前股东";
      //   } else if (key == "output") {
      //     name = "对外投资";
      //   } else if (key == "keypeople") {
      //     name = "企业高管";
      //   }
      // }

      for (var [key, modules] of Object.entries(moduleDependencies)) {
        var name = "";
        if (key == "input") {
          name = "当前股东";
        } else if (key == "output") {
          name = "对外投资";
        } else if (key == "keypeople") {
          name = "企业高管";
        }
        if (modules.length > 0) {
          modules.forEach(item => {
            if (name == "当前股东") {
              data.links.push({
                source: item.id ? item.id : item.personId,
                target: this.companyName,
                name: "控股"
              });
            } else if (name == "对外投资") {
              data.links.push({
                source: this.companyName,
                target: item.id ? item.id : item.personId,
                name: "投资"
              });
            } else if (name == "企业高管") {
              data.links.push({
                source: item.id ? item.id : item.personId,
                target: this.companyName,
                name: item.duty
              });
            }
            data.nodes.push({
              name: item.name,
              id: item.id ? item.id : item.personId,
              symbolSize: defaultSymbolSize,
              category:
                name == "当前股东"
                  ? 0
                  : name == "对外投资"
                  ? 1
                  : name == "企业高管"
                  ? 2
                  : ""
            });
            data.nodes.forEach(node => {
              if (node.name === item.name) {
                node.symbolSize += 8;
              }
            });
            if (item.children) {
              if (item.children.length > 0) {
                pushDataChildren(key, item);
              }
            }
            if (item.keypeople) {
              if (item.keypeople.length > 0) {
                pushDataKeypeople(key, item);
              }
            }
          });
        }
      }
      data.nodes.forEach(node => {
        if (node.category === 0) {
          node.itemStyle = {
            color: color1
          };
        } else if (node.category === 1) {
          node.itemStyle = {
            color: color2
          };
        } else if (node.category === 2) {
          node.itemStyle = {
            color: color3
          };
        }
        if (node.symbolSize === 0) {
          node.symbolSize = defaultSymbolSize;
        }
      });
      data.links.forEach(link => {
        link.label = {
          align: "center",
          fontSize: 12
        };

        if (link.name === "控股") {
          link.lineStyle = {
            color: color1
          };
        } else if (link.name === "投资") {
          link.lineStyle = {
            color: color2
          };
        } else {
          link.lineStyle = {
            color: color3
          };
        }
      });

      let categories = [
        {
          name: "当前股东",
          itemStyle: {
            color: color1
          }
        },
        {
          name: "对外投资",
          itemStyle: {
            color: color2
          }
        },
        {
          name: "企业高管",
          itemStyle: {
            color: color3
          }
        }
      ];
      var option = {
        legend: [
          {
            // selectedMode: 'single',
            data: categories.map(x => x.name),
            // icon: 'circle'
            textStyle: {
              color: "#fff"
            }
          }
        ],
        series: [
          {
            type: "graph",
            layout: "force",
            symbolSize: defaultSymbolSize,
            draggable: true,
            roam: true,
            focusNodeAdjacency: true,
            categories: categories,
            edgeSymbol: edgeSymbol,
            // edgeSymbolSize: [80, 10],
            edgeLabel: {
              normal: {
                show: true,
                textStyle: {
                  fontSize: 20
                },
                formatter(x) {
                  return x.data.name;
                }
              }
            },
            label: {
              show: true
            },
            force: {
              repulsion: 2000,
              edgeLength: 120,
              friction: 0.1,
              layoutAnimation: false
            },
            data: data.nodes,
            links: data.links
          }
        ]
      };
      relation.setOption(option);
    },
    getBusinessLabel() {
      let params = {
        entId: this.$route.query.entId
      };
      api.getBusinessLabel(params).then(res => {
        this.businessLabel = res.data.baseLabel;
        if (this.businessLabel.industry) {
          var arr = this.businessLabel.industry;
          var arr2 = this.businessLabel.industry.split("|");
          this.industryTitle = arr2[0] + " | " + arr2[1] + " | " + arr2[2];
          this.businessLabel.industry = arr.split("|")[2];
        }
        this.specialLabel = res.data.specialLabel.splice(0, 4);
        for (var i = 0, len = res.data.specialLabel.length; i < len; i += 6) {
          this.specialLabel2.push(res.data.specialLabel.slice(i, i + 6));
        }
      });
    }
  },
  created() {},
  mounted() {
    this.getBusinessLabel();
    http("post", this.nom + "/api", "json", {
      companyname: this.companyName,
      lable: "maps"
    }).then(res => {
      this.chart1(res.output);
    });
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/tableScrollbar.less";
@import "../../assets/less/style.less";
@import "../../assets/less/right.less";
@import "../../assets/less/moreThanThree.less";
.stockApp {
  background: url("../../assets/img/bg.png") no-repeat top;
  display: flex;
}
.stock {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
main {
  width: 100%;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  .right {
    flex: 1;
    height: auto;
    margin-right: 0px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0 22px;
    box-sizing: border-box;
    .mainTop {
      display: flex;
      .underHeader {
        display: inline-block;
        height: 54px;
        line-height: 54px;
        padding-left: 0px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #dfecf7;
        img {
          width: 12px;
          height: 16px;
        }
      }
      /deep/ .el-breadcrumb__inner {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #dfecf7;
      }
    }
    .marinBottom_top {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      background: rgba(5, 43, 79, 0.3);
      border: 1px solid #08396a;
      padding: 0 20px;
      box-sizing: border-box;
      .topBox_1 {
        width: 100%;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .businessLabelBox {
          display: flex;
          flex: 1;
          height: 100%;
          h3 {
            margin-right: 10px;
            margin-left: 9px;
            font-size: 22px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #f1f8ff;
          }
          .column {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            padding: 20px 0;
            box-sizing: border-box;
          }
          .names {
            display: flex;
            align-items: center;
          }
          .tags {
            display: flex;
            align-items: center;
            margin-top: 5px;
          }
          .img {
            display: flex;
            align-items: center;
            height: 100px;
          }
          p {
            width: auto;
            height: 20px;
            line-height: 20px;
            padding: 0 20px;
            margin-left: 10px;
            background: rgba(60, 152, 245, 0.2);
            border-radius: 2px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #3c98f5;
          }

          p:nth-child(odd) {
            // background: rgba(255, 145, 107, 0.2);
            background: rgba(0, 153, 68, 0.2);
            // color: #ff916b;
            color: #009944;
          }
          .ckgd {
            margin-left: 20px;
            display: flex;
            align-items: center;
            color: #128bed;
            flex-direction: column;
            justify-content: space-around;
            img {
              vertical-align: middle;
              height: 12px;
            }
          }
        }
        .buttonBox {
          display: flex;
          align-items: center;
          button {
            width: 90px;
            height: 32px;
            background: #177fe8;
            border-radius: 2px;
            margin-left: 21px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #dfecf7;
            border: 0;
            img {
              width: 10px;
              height: 10px;
            }
          }
          p {
          }
          font-size: 12px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #bac7d5;
        }
      }
    }
    .nav {
      margin-top: 12px;
      height: 48px;
      background: rgba(5, 43, 79, 0.8);
      border: 1px solid #08396a;
      border-radius: 2px 2px 0px 0px;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      img {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
      p {
        margin-left: 5px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #3c98f5;
        cursor: pointer;
      }
      div {
        display: flex;
        align-items: center;
        p {
          margin-left: 50px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #6d84a2;
        }
        .navStyle {
          color: #dfecf7;
          border-bottom: 1px solid #368ce4;
          line-height: 44px;
        }
      }
    }
    .bottom {
      margin-top: 1px;
      width: 100%;
      height: 600px;
      background: rgba(5, 43, 79, 0.3);
      border: 1px solid #08396a;
      border-radius: 0px 0px 2px 2px;
    }
  }

  .mainBottom {
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
  }
}
.pharmaLeft_Box {
  display: flex;
}
.title-img {
  img {
    width: 16px;
    height: 54px;
    margin: auto;
    margin-right: 23px;
    margin-left: -16px;
    z-index: 99;
    position: relative;
    // top:50%;
  }
}
#chart1 {
  width: 100%;
  height: 600px;
}
#relation {
  width: 100%;
  height: 600px;
}
</style>
 


// WEBPACK FOOTER //
// src/view/enterprises/atlas.vue